export default __webpack_public_path__ + "static/media/About_2.33394dc4.png";